<template>
  <svg
    viewBox="0 0 33 41"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.252 1H2.4113C1.5208 1 1.07445 2.07629 1.70359 2.7065L18.6329 19.6648C19.0207 20.0533 19.0228 20.6818 18.6377 21.0729L1.67562 38.2984C1.05313 38.9305 1.50096 40 2.38815 40H12.2479C12.5158 40 12.7725 39.8925 12.9605 39.7016L31.3043 21.0729C31.6895 20.6818 31.6874 20.0533 31.2995 19.6648L12.9597 1.2935C12.7721 1.10559 12.5175 1 12.252 1Z"
    />
  </svg>
</template>
<style>
svg path {
  fill: currentColor !important;
  stroke: currentColor !important;
}
</style>
